module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAICAYAAAAm06XyAAAAAXNSR0IArs4c6QAAANxJREFUKFNjZMABjnCJSP1jYl7449/feLdvb55hU8aITXAPL68w23/uQwwMDFr/Gf5f+c34zcHl8+e36GoxNB9hEOH9y82yj5GRwQSu+D/DKaavf1xsGN58RjYARfMqBgZOCR6JbQwMDA7otvxn+L//35eXXo4MDD9gcnDNZxgYWL9xS6xjYGTwwRUODAwMm65/eRGSzsDwG6QGrPk/AwPTYR7xJQwMjJF4NEKk/v9fuu/ry7gGBoZ/YM0HecRnMDIwphPUiFAw3e7LiyzGg9ziHYyMjOUkaIS5oB0A1d5Bc7e5f+AAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/up.png
// module id = WY0H
// module chunks = 3